import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class EntityRef
*  Информация о связанных данных
*/
export class EntityRef extends ActiveModel {

  /**
  * id
  * Идентификатор связанных данных<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * displayName
  * Название связанных данных<br>
  */
  @ActiveField()
  displayName?: null | string
}
